<template>
  <div class='EnbCheckoutProd01'>
    <div @click="Del(data)" class="x">
      x
    </div>
    <div class="img">
      <div class="c-img"><img v-if="data.img.length" :src="api + data.img[0].img"></div>
    </div>
    <div class="desc">
      {{ data.name }}
    </div>
  </div>
</template>

<script>
import api from '@/mixins/api'
export default {
  name: 'EnbCheckoutProd01',
  props: ['data'],
  mixins: [api],
  methods: {
    Del (data) {
      this.$emit('DelLike', data)
    }
  }
}
</script>

<style scoped>
.EnbCheckoutProd01 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.x {
  width: 5%;
  cursor: pointer;
  font-weight: bold;
}

.img {
  width: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.c-img {
  width: 85px;
  height: 85px;
  overflow: hidden;
  border-radius: 5px;
}

img {
  width: 90px;
  height: 90px;
}

.desc {
  width: 60%;
  text-align: left;
}

@media (max-width: 500px) {
  img {
    width: 60px;
    height: 60px;
  }
}
</style>
